export const fileScanResultClean = 'CLEAN';
export const fileScanResultInfected = 'INFECTED';
export const fileScanResultError = 'ERROR';
export const fileScanResultPending = 'PENDING';
